import "./index.less";

import React, { FC, useState } from "react";
import { Button, Modal, message, Radio, Space } from "antd";

import http from "../../../request/http";
import { TOrgListItem } from "../../../interface";
import { ApiUrl } from "../../../request";

const OrgApplyBtn: FC = () => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgId, setOrgValue] = useState<number>();
  const [orgList, setOrgList] = useState<TOrgListItem[]>([]);

  // 请求组织机构列表
  const requestOrgList = () => {
    http<TOrgListItem[]>("get", ApiUrl.orgList).then((res) => {
      if (res.code === 200) {
        setOrgList(res.data || []);
        setOrgValueDefault();
      }
    });
  };

  // 请求之前设置的组织机构
  const requestOrgCurrent = () => {
    http<any>("get", ApiUrl.orgQuery)
      .then((res) => {
        if (res.code === 200 && res.data?.cdcId !== undefined) {
          setOrgValue(res.data.cdcId);
          updateScroll();
        } else {
          setOrgValueDefault();
        }
      })
      .catch(() => {
        setOrgValueDefault();
      });
  };

  const toggleVisible = () => {
    if (!visible) {
      requestOrgList();
      requestOrgCurrent();
    }
    setVisible(!visible);
  };

  const hancleChangeOrgValue = (e: any) => {
    setOrgValue(e.target.value);
  };

  const saveOrgHandle = () => {
    const res = orgList.find((item) => item.cdcId === orgId);
    if (!res) {
      return;
    }
    setLoading(true);
    http<any>("post", ApiUrl.orgSave, {
      cdcId: res.cdcId,
      cdcName: res.cdcName,
      relationId: res.relationBdcId,
    })
      .then((res) => {
        if (res.code === 200) {
          toggleVisible();
          message.success("保存成功");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // 回显组织机构时，自动滚动到视野区域
  const updateScroll = () => {
    setTimeout(() => {
      document
        .getElementsByClassName("jxc-crm-radio-wrapper-checked")[0]
        ?.scrollIntoView();
    }, 100);
  };

  // 当没默认机构时，取 全国 机构
  const setOrgValueDefault = () => {
    if (orgId) {
      return;
    }
    const defaultOrg = orgList.find((item) => item.cdcId === orgId);
    if (defaultOrg) {
      setOrgValue(defaultOrg.cdcId);
      updateScroll();
    }
  };

  return (
    <>
      <Button
        type="primary"
        ghost
        style={{ margin: 8 }}
        onClick={toggleVisible}
      >
        默认机构设置
      </Button>
      {visible && (
        <Modal
          visible={visible}
          title="默认机构设置"
          confirmLoading={loading}
          cancelText="取消"
          okText="保存"
          onOk={saveOrgHandle}
          onCancel={toggleVisible}
        >
          <div className="mianapp-org-list-wrap">
            <Radio.Group onChange={hancleChangeOrgValue} value={orgId}>
              <Space direction="vertical">
                {orgList.map((item) => {
                  return (
                    <Radio value={item.cdcId} key={item.cdcId}>
                      {item.cdcName}
                    </Radio>
                  );
                })}
              </Space>
            </Radio.Group>
          </div>
          <div className="mianapp-org-tips">
            选择后，在查看进货价、仓报价时，将以此机构为默认机构
          </div>
        </Modal>
      )}
    </>
  );
};

export default OrgApplyBtn;
